import { deepMerge } from './deepMerge';
function coerce(el, val) {
    if (el.dataset.coerce === 'false') {
        return val;
    }
    if (typeof val === 'string') {
        const n = Number(val);
        if (isNaN(n) || !isFinite(n) || !/^\d+$/.test(val)) {
            return val;
        }
        return n;
    }
    return val;
}
class ElementBasedError extends Error {
    constructor(message, el) {
        super(message);
        this.el = el;
    }
}
class SerializationError extends ElementBasedError {
}
const patterns = {
    key: /[\w-]+|(?=\[\])/gi,
    named: /^[\w-]+$/i,
    push: /^$/,
    validate: /^[a-z][\w-]*(?:\[(?:\d*|[\w-]+)\])*$/i,
};
function serializeInput(el) {
    const tag = el.tagName.toLowerCase();
    switch (tag) {
        case 'textarea':
            return el.value;
        case 'select':
            const sel = el;
            if (sel.multiple) {
                const out = [];
                Array.from(sel.childNodes).forEach(ch => {
                    if (ch.selected) {
                        out.push(coerce(sel, ch.value));
                    }
                });
                return coerce(sel, out);
            }
            return coerce(sel, sel.value);
        case 'input':
            const i = el;
            const type = el.getAttribute('type');
            switch (type) {
                case 'radio':
                    return coerce(i, i.checked ? (i.getAttribute('value') ? i.value : true) : undefined);
                case 'checkbox':
                    return coerce(i, i.checked
                        ? i.getAttribute('value')
                            ? i.value
                            : true
                        : i.getAttribute('value')
                            ? undefined
                            : false);
                case 'range':
                case 'number':
                    const v = i.valueAsNumber;
                    // Browser that don't really support `valueAsNumber`
                    // (Edge) https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/669685/
                    if (v === undefined || Number.isNaN(v)) {
                        return parseFloat(i.value);
                    }
                    return i.valueAsNumber;
                case 'date':
                case 'datetime-local':
                    // fallback for ios and such, enjoy your shit
                    return i.valueAsDate ? i.valueAsDate.toJSON() : new Date(i.value).toJSON();
                case 'tel':
                    return i.value.replace(/[^\+0-9]/gi, '');
                default:
                    return i.value;
            }
    }
    throw new SerializationError('Could not serialize element', el);
}
export function serializeFormJSON(form) {
    const json = {};
    const shouldIgnore = (value) => value === undefined || value === false || value === null;
    Array.from(
    // tslint:disable-next-line:no-unnecessary-type-assertion
    (form.querySelectorAll('input[name], textarea[name], select[name]'))).forEach(el => {
        let name = el.getAttribute('name');
        let value = serializeInput(el);
        if (value === '') {
            if (el.required) {
                return;
            }
            value = null;
        }
        if (name.endsWith('?')) {
            if (value === null) {
                return;
            }
            name = name.slice(0, -1);
        }
        // skip invalid keys
        if (!patterns.validate.test(name)) {
            return;
        }
        let k;
        const keys = name.match(patterns.key);
        let merge = value;
        let reverseKey = name;
        if (!keys) {
            throw new SerializationError('Could not match keys', el);
        }
        // tslint:disable-next-line:no-conditional-assignment
        while ((k = keys.pop()) !== undefined) {
            // adjust reverse_key
            reverseKey = reverseKey.replace(new RegExp('\\[' + k + '\\]$'), '');
            // push
            if (k.match(patterns.push)) {
                merge = shouldIgnore(merge) ? [] : [merge];
            }
            else if (k.match(patterns.named)) {
                // named
                merge = { [k]: merge };
            }
        }
        deepMerge(json, merge);
    });
    return json;
}
//# sourceMappingURL=form-serialization.js.map